import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { consultantmage, logo, pharmacy, userpatient } from "../Constant/Index";
import { useSelector } from "react-redux";
import { FaBars, FaTimes, FaPhoneAlt } from "react-icons/fa";
import { ref, onValue, remove } from "firebase/database";
import { database } from "../firebase";

const Header = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const currentPath = location.pathname;
	const token = useSelector((state) => state?.Auth?.token);
	const userprofie = useSelector((state) => state?.Auth?.userprofie);
	const userDetail = useSelector((state) => state?.Auth?.users);
	const myrole = useSelector((state) => state?.Auth?.role);
	const [menuOpen, setMenuOpen] = useState(false);
	const [callData, setCallData] = useState(null);
	const audioRef = useRef(null);
	const currentUserId = userDetail?.id;

	const toggleMenu = () => {
		setMenuOpen(!menuOpen);
	};

	const personalInfoPages = [
		"/personal-info",
		"/change-password",
		"/medical-report",
		"/my-order",
		"/my-order-detail",
		"/my-consultations",
		"/user-shift-edit",
		"/consultation-detail",
		"/past-consultations",
		"/current-consultations",
		"/current-consultations-detail",
		"/past-consultations-detail",
		"/user-chat",
		"/user-prescription",
		"/user-prescription-placeorder",
		"/user-notes",
		"/user-billing-detail",
		"/user-prescription-address",
		"/user-thankyou",
		"/user-videocall",
		"/user-write-now",
	];

	const physicianInfoPages = [
		"/physician-personal-info",
		"/physician-password",
		"/physician-myconsultations",
		"/physician-consultation-detail",
		"/physician-current-consultations",
		"/physician-current-detail",
		"/physician-past-consultations",
		"/physician-past-detail",
		"/physician-current-chat",
		"/physician-past-chat",
		"/physician-video-call",
		"/physician-prescription",
		"/write-prescription",
		"/physician-notes",
		"/physician-write-notes",
	];

	const pharmacyInfoPages = [
		"/pharmacy-info",
		"/pharmacy-change-password",
		"/prescription-orders-all",
		"/prescription-orders-pending",
		"/prescription-orders-inprogress",
		"/prescription-orders-complete",
		"/prescription-orders-details",
	];

	const isPersonalInfoPage = personalInfoPages.includes(currentPath);
	const isPhysicianPersonalInfoPage = physicianInfoPages.includes(currentPath);
	const isPharmacyInfoPage = pharmacyInfoPages.includes(currentPath);
	const ringtoneRef = useRef(null);

	// Firebase listener
	useEffect(() => {
		if (!currentUserId) return;

		const callRef = ref(database, `calls/${currentUserId}`);

		const unsub = onValue(callRef, (snapshot) => {
			const data = snapshot.val();
			setCallData(data || null);

			if (data?.status === "incoming") {
				playRingtone();
			} else {
				stopRingtone();
			}
		});

		return () => {
			unsub();
			stopRingtone();
		};
	}, [currentUserId]);

	// Ringtone play/stop functions
	const playRingtone = () => {
		if (!ringtoneRef.current) {
			ringtoneRef.current = new Audio("/ringtone.mp3"); // apne ringtone ka path
			ringtoneRef.current.loop = true;
		}
		ringtoneRef.current.play().catch(() => {});
	};

	const stopRingtone = () => {
		if (ringtoneRef.current) {
			ringtoneRef.current.pause();
			ringtoneRef.current.currentTime = 0;
		}
	};

	// Accept call
	const acceptCall = () => {
		stopRingtone();
		remove(ref(database, `calls/${currentUserId}`));
		if (callData?.roomId) {
			navigate(`/room/${callData.roomId}?type=one-on-one`);
		}
	};

	// Decline call
	const cancelCall = () => {
		stopRingtone();
		remove(ref(database, `calls/${currentUserId}`));
		setCallData(null);
	};

	return (
		<header className="site-header">
			<div className="container">
				<div className="header-wrapper py-3">
					<div className="header-start d-flex gap-sm-0 justify-content-between align-items-center w-100">
						<div className="logo-wrapper d-flex align-items-center justify-content-between">
							<div className="header-logo">
								<figure className="header-logo">
									<Link to="/">
										<img src={logo} className="logo-here light-image" alt="" />
									</Link>
								</figure>
							</div>
						</div>
						{/* Incoming Call Notification */}
						{/* Incoming Call Popup */}
						{callData?.status === "incoming" &&
							(myrole === "patient" || myrole === "physician") && (
								<div
									style={{
										position: "fixed",
										bottom: "20px",
										right: "20px",
										background: "#fff",
										padding: "12px 15px",
										borderRadius: "12px",
										boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
										zIndex: 9999,
										display: "flex",
										alignItems: "center",
										gap: "12px",
										minWidth: "300px",
										animation: "slideIn1 0.3s ease-out",
									}}
								>
									{/* Caller Image */}
									<img
										src={callData.callerImage || "/default-avatar.png"}
										alt="Caller"
										style={{
											width: "50px",
											height: "50px",
											borderRadius: "50%",
											objectFit: "cover",
										}}
									/>

									{/* Caller Info */}
									<div style={{ flex: 1 }}>
										<strong style={{ display: "block", fontSize: "16px" }}>
											{callData.callerName}
										</strong>
										<span style={{ fontSize: "14px", color: "#555" }}>
											Incoming call...
										</span>
									</div>

									{/* Accept Button */}
									<button
										onClick={acceptCall}
										style={{
											background: "#28a745",
											color: "#fff",
											border: "none",
											padding: "6px 10px",
											borderRadius: "6px",
											fontSize: "12px",
										}}
									>
										Accept
									</button>

									{/* Decline Button */}
									<button
										onClick={cancelCall}
										style={{
											background: "#dc3545",
											color: "#fff",
											border: "none",
											padding: "6px 10px",
											borderRadius: "6px",
											fontSize: "12px",
										}}
									>
										Decline
									</button>
								</div>
							)}

						{/* Animation CSS */}
						{/* Hamburger Icon */}
						<div className="d-lg-none">
							<button
								onClick={toggleMenu}
								className="btn hamburger-btn p-0 border-0 bg-transparent"
							>
								{menuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
							</button>
						</div>
						<div className="d-lg-flex align-items-center gap-3 d-none">
							<ul className="header-link list-unstyled d-md-flex flex-lg-row align-items-center gap-5 mb-0 z-index-1 d-none">
								<li className="single-item">
									<Link
										to="/"
										className="header-link level-7 link-here primary-regular-font text-decoration-none extra-color-1"
									>
										Home
									</Link>
								</li>
								<li className="single-item">
									<Link
										to="/about-us"
										className="header-link level-7 link-here primary-regular-font text-decoration-none extra-color-1"
									>
										About Us
									</Link>
								</li>
								<li className="single-item">
									<Link
										to="/how-it-work"
										className="header-link level-7 link-here primary-regular-font text-decoration-none extra-color-1"
									>
										How it works
									</Link>
								</li>
								<li className="single-item">
									<Link
										to="/contact-us"
										className="header-link level-7 link-here primary-regular-font text-decoration-none extra-color-1"
									>
										Contact us
									</Link>
								</li>
								<ul className="navigation-list">
									{!(
										(token && myrole == "patient") ||
										(token && myrole == "physician") ||
										(token && myrole == "pharmacy")
									) && (
										<li className="single-item">
											<Link
												to="/sign-up"
												className="start-now btn wrapper-btn-main log-in level-7 primary-regular-font text-decoration-none"
											>
												<span className="bg-wrapper">GET STARTED</span>
											</Link>
										</li>
									)}
									{token && myrole == "patient" && (
										<li className="single-item">
											<Link
												style={{
													textDecoration: "none",
													color: "#000",
												}}
												to="/personal-info"
											>
												<div className="user-profile d-flex align-items-center gap-3">
													<div className="edit-btn-profile">
														{!userprofie ? (
															<img
																src={userDetail?.profile_image_url}
																className="img-fluid nav-anchor-bg"
																alt=""
															/>
														) : (
															<img
																src={userprofie}
																className="img-fluid nav-anchor-bg"
																alt=""
															/>
														)}
													</div>
													<h4 className="secondary-bold-font level-7 mb-0 text-decoration-none dark-color">
														{userDetail?.first_name}
													</h4>
												</div>
											</Link>
										</li>
									)}
									{token && myrole == "physician" && (
										<li className="single-item">
											<Link
												style={{
													textDecoration: "none",
													color: "#000",
												}}
												to="/physician-personal-info"
											>
												<div className="physician-profile d-flex align-items-center gap-3">
													<div className="edit-btn-profile">
														{!userprofie ? (
															<img
																src={userDetail?.profile_image_url}
																className="img-fluid nav-anchor-bg"
																alt=""
															/>
														) : (
															<img
																src={userprofie}
																className="img-fluid nav-anchor-bg"
																alt=""
															/>
														)}
													</div>
													<h4 className="secondary-bold-font level-7 mb-0 text-decoration-none dark-color">
														{userDetail?.first_name}
													</h4>
												</div>
											</Link>
										</li>
									)}
									{token && myrole == "pharmacy" && (
										<li className="single-item">
											<Link to="/pharmacy-perosnal-info">
												<div className="pharmacy-profile d-flex align-items-center gap-3">
													<div className="edit-btn-profile">
														{!userprofie ? (
															<img
																src={userDetail?.profile_image_url}
																className="img-fluid nav-anchor-bg"
																alt=""
															/>
														) : (
															<img
																src={userprofie}
																className="img-fluid nav-anchor-bg"
																alt=""
															/>
														)}
													</div>
													<h4 className="secondary-bold-font level-7 mb-0 text-decoration-none dark-color">
														{userDetail?.first_name}
													</h4>
												</div>
											</Link>
										</li>
									)}
								</ul>
							</ul>
						</div>
						{/* Mobile Menu (only on small screens) */}
						{menuOpen && (
							<div className="mobile-nav d-lg-none mt-0">
								<ul className="list-unstyled d-flex flex-column gap-3">
									<li>
										<Link
											to="/"
											className="level-7 link-here primary-regular-font text-decoration-none extra-color-1"
										>
											Home
										</Link>
									</li>
									<li>
										<Link
											to="/about-us"
											className="level-7 link-here primary-regular-font text-decoration-none extra-color-1"
										>
											About Us
										</Link>
									</li>
									<li>
										<Link
											to="/how-it-work"
											className="level-7 link-here primary-regular-font text-decoration-none extra-color-1"
										>
											How it works
										</Link>
									</li>
									<li>
										<Link
											to="/contact-us"
											className="level-7 link-here primary-regular-font text-decoration-none extra-color-1"
										>
											Contact us
										</Link>
									</li>
									{!token && (
										<li>
											<Link
												to="/sign-up"
												className="start-now btn wrapper-btn-main log-in level-7 primary-regular-font text-decoration-none"
											>
												<span className="bg-wrapper">GET STARTED</span>
											</Link>
										</li>
									)}
									{token && (
										<li>
											<Link
												to={
													myrole === "patient"
														? "/personal-info"
														: myrole === "physician"
														? "/physician-personal-info"
														: "/pharmacy-perosnal-info"
												}
												className="d-flex align-items-center gap-2 text-decoration-none"
											>
												<img
													src={userprofie || userDetail?.profile_image_url}
													className="rounded-circle"
													width={40}
													height={40}
													alt="Profile"
												/>
												<span className="fw-bold level-7 link-here primary-medium-font text-decoration-none extra-color-1">
													{userDetail?.first_name}
												</span>
											</Link>
										</li>
									)}
								</ul>
							</div>
						)}
					</div>
				</div>
			</div>

			{/* Ringtone */}
			<audio ref={audioRef} src="/ringtone.mp3" loop preload="auto" />
		</header>
	);
};

export default Header;
